import React, { Fragment, useState } from 'react';
import { Container, Collapse, Row, Col } from 'reactstrap';
import { MinusIcon, PlusIcon } from '../../common/icons';
import { Link } from 'react-router-dom';
import * as Icons from '../../common/icons/emergingTechnologiesServiceIcons';
// import { HashLink as Link } from 'react-router-hash-link';
// import techImg from '../../assets/images/landingpage/smiling-executives-waiting-meeting.png'


const TechIndustryQuality = (props) => {
    const techIndustryData = props?.techIndustryQualityData;
    const [state, setState] = useState({
        articleOpen: 0,
        moreInfoOpen: true
    });

    const toggle = (index) => {
        setState({
            articleOpen: index,
            moreInfoOpen: !state.moreInfoOpen
        });
    };

    return (
        <section className='Tech-Industry-Quality'>
            <div className='tech-content py-5' style={{ backgroundImage: `url(${techIndustryData?.bgImg})` }}>
                <div className='bg-color-rgba'>
                    <Container className="py-5 pe-5">
                        <Row className="justify-content-start">
                            <Col lg="7" md="7" className="align-self-start">
                                <div className='page-content pb-5'>
                                    <h3>{techIndustryData?.pageHeading}</h3>
                                    {techIndustryData?.futureProof?.length > 0 && <div className='my-3'>
                                        {techIndustryData?.futureProof?.map((future, index) => {
                                            const Icon = Icons[future?.icon] || null;
                                            // const Icon = future?.icon;
                                            return (
                                                <p key={index}>
                                                    {Icon && <Icon />} {future?.title}
                                                </p>
                                            );
                                        })}
                                    </div>}
                                    {console.log('-------techIndustryData------>', techIndustryData?.pageParagraph?.text)}
                                    <p>{techIndustryData?.pageParagraph?.text}{techIndustryData?.pageParagraph?.link && <Link className='text-decoration-none text-white' to={window?.location?.origin}>{typeof techIndustryData?.pageParagraph?.link === 'function'
                                        ? techIndustryData?.pageParagraph?.link()
                                        : techIndustryData?.pageParagraph?.link}</Link>} {techIndustryData?.pageParagraph?.text1}</p>
                                    {techIndustryData?.pageParagraph1 && <p>{techIndustryData?.pageParagraph1?.text}<Link className='text-decoration-none text-white' to={window?.location?.origin}>{techIndustryData?.pageParagraph1?.link}</Link> {techIndustryData?.pageParagraph1?.text1}</p>}
                                </div>
                                {techIndustryData?.faqData?.length > 0 && <div className='tech-faq'>
                                    {techIndustryData?.faqData?.map((faq, index) => {
                                        return (
                                            <Fragment key={index}>
                                                <div className='d-flex justify-content-start align-items-center gap-3' onClick={() => toggle(index)} style={{ marginBottom: '1rem' }}>
                                                    {state && index === state?.articleOpen ? <MinusIcon /> : <PlusIcon />}
                                                    <h4>{faq?.title}</h4>
                                                </div>
                                                <Collapse isOpen={index === state?.articleOpen}>
                                                    <div className='tech-faq-content'>
                                                        <p className='tech-faq-content-body'>
                                                            {faq?.paragraph}
                                                        </p>
                                                    </div>
                                                </Collapse>
                                            </Fragment>
                                        )
                                    })}
                                </div>}
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </section>
    );
}

export default TechIndustryQuality;
